import { api } from './api';

export const isFlaggedForRevision = async (courseId: number, nodeId: number): Promise<boolean> => {
  const res = await api.get<{ data: { flagged: boolean } }>(`/api/tutor/courses/${courseId}/nodes/${nodeId}/revision`);
  return res.data.data.flagged;
};

export const flagForRevision = async (courseId: number, nodeId: number): Promise<void> => {
  await api.post(`/api/tutor/courses/${courseId}/nodes/${nodeId}/revision`);
};

export const unflagForRevision = async (courseId: number, nodeId: number): Promise<void> => {
  await api.delete(`/api/tutor/courses/${courseId}/nodes/${nodeId}/revision`);
};

export const isStudentTopicRevision = async (courseId: number, nodeId: number): Promise<boolean> => {
  const res = await api.get<{ data: { flagged: boolean } }>(`/api/student/courses/${courseId}/topics/${nodeId}/revision`);
  return res.data.data.flagged;
};
